import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../features/auth/services/auth";
import { JSX, useEffect, useState } from "react";
import AppLoader from "../assets/images/appLoader.gif";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const auth = await isAuthenticated();
      setIsAuth(auth);
    };
    checkAuth();
  }, []);
  if (isAuth === null) return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <img src={AppLoader} alt="Loading website definition" width={130} />
  </div>;
  return isAuth ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
